(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["animal-book-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ocl-book-purchase')) {
    customElements.define('ocl-book-purchase', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        const source = this.querySelector('[data-books-json]');
        if (!source) return;
        this.data = JSON.parse(source.textContent);
        this.books = this.data.products;
        this.bundle = this.books[3];
        if (this.books.length !== 4 || this.books.some(book => !book.handle || !book.variant?.id)) return;
        this.ready = true;
        this.abort = new AbortController();
        this.form = this.querySelector('form');
        this.quantity = this.form.elements.quantity;
        this.add = this.querySelector('[data-book-add]');
        this.error = this.querySelector('[data-book-error]');
        this.status = this.querySelector('[data-book-status]');
        this.modeGroup = this.querySelector('[data-book-modes]');
        this.titleGroup = this.querySelector('[data-book-titles]');
        this.singleHandle = this.dataset.current === this.bundle.handle ? this.books[0].handle : this.dataset.current;
        this.mode = this.dataset.current === this.bundle.handle ? 'set' : 'single';
        this.money = new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: this.dataset.currency || 'USD' });
        this.modeGroup.hidden = this.dataset.collectionMode === 'true';
        this.querySelectorAll('[data-quantity-step]').forEach(button => { button.hidden = false; });
        this.restore();
        this.addEventListener('change', event => {
          if (event.target.matches('[data-book-modes] input')) {
            this.mode = event.target.value;
            this.update(true);
          } else if (event.target.matches('[data-book-titles] input')) {
            this.singleHandle = event.target.value;
            this.update(true);
          } else if (event.target === this.quantity) {
            this.quantity.value = String(this.normalQuantity());
            this.refreshQuantity();
          }
        }, { signal: this.abort.signal });
        this.querySelectorAll('[data-quantity-step]').forEach(button => button.addEventListener('click', () => {
          this.quantity.value = String(Math.max(1, Math.min(99, this.normalQuantity() + Number(button.dataset.quantityStep))));
          this.refreshQuantity();
        }, { signal: this.abort.signal }));
        this.form.addEventListener('submit', event => this.submit(event), { signal: this.abort.signal });
        window.addEventListener('popstate', () => this.restore(), { signal: this.abort.signal });
      }
      disconnectedCallback() { this.abort?.abort(); this.ready = false; }
      format(cents) { return this.money.format(cents / 100); }
      normalQuantity() { return Math.max(1, Math.min(99, Math.trunc(Number(this.quantity.value)) || 1)); }
      refreshQuantity() {
        const quantity = this.normalQuantity();
        this.querySelector('[data-quantity-step="-1"]').disabled = quantity <= 1 || this.busy;
        this.querySelector('[data-quantity-step="1"]').disabled = quantity >= 99 || this.busy;
      }
      restore() {
        const params = new URL(window.location.href).searchParams;
        const selected = this.books.find(book => book.handle === params.get('book_choice'));
        const single = this.books.slice(0, 3).find(book => book.handle === params.get('single_book'));
        this.singleHandle = single?.handle || (selected && selected !== this.bundle ? selected.handle : this.dataset.current !== this.bundle.handle ? this.dataset.current : this.books[0].handle);
        this.mode = selected ? (selected === this.bundle ? 'set' : 'single') : (this.dataset.current === this.bundle.handle ? 'set' : 'single');
        if (this.dataset.collectionMode === 'true') this.mode = 'set';
        this.update(false);
      }
      update(push) {
        const single = this.books.find(book => book.handle === this.singleHandle) || this.books[0];
        this.active = this.mode === 'set' ? this.bundle : single;
        this.dataset.mode = this.mode;
        this.modeGroup.querySelectorAll('input').forEach(input => { input.checked = input.value === this.mode; });
        this.titleGroup.querySelectorAll('input').forEach(input => { input.checked = input.value === single.handle; });
        this.titleGroup.hidden = this.mode === 'set';
        this.querySelector('[data-single-visual]').hidden = this.mode === 'set';
        this.querySelector('[data-set-visual]').hidden = this.mode !== 'set';
        const image = this.querySelector('[data-single-visual] img');
        if (image.dataset.handle !== single.handle) {
          image.removeAttribute('srcset');
          image.src = single.image;
          image.alt = single.title;
          image.dataset.handle = single.handle;
        }
        this.querySelector('[data-book-title]').textContent = this.active.title;
        this.querySelector('[data-book-price]').textContent = this.format(this.active.variant.price);
        this.querySelector('[data-single-price]').textContent = this.format(single.variant.price);
        const saving = this.books.slice(0, 3).reduce((sum, book) => sum + book.variant.price, 0) - this.bundle.variant.price;
        const badge = this.querySelector('[data-book-saving]');
        badge.hidden = this.mode !== 'set' || saving <= 0;
        badge.textContent = this.data.labels.save.replace('__amount__', this.format(saving));
        badge.title = this.data.labels.separate;
        this.querySelector('[data-book-description]').innerHTML = this.active.description;
        this.form.elements.id.value = this.active.variant.id;
        if (this.form.elements['product-id']) this.form.elements['product-id'].value = this.active.id;
        this.add.disabled = !this.active.variant.available;
        this.add.textContent = this.active.variant.available ? this.data.labels.add : this.data.labels.sold_out;
        this.error.hidden = true;
        this.querySelector('[data-book-cart]').hidden = true;
        this.refreshQuantity();
        if (push) {
          const url = new URL(window.location.href);
          url.searchParams.set('book_choice', this.active.handle);
          url.searchParams.set('single_book', single.handle);
          url.searchParams.delete('variant');
          window.history.pushState(window.history.state, '', url);
          this.status.textContent = this.active.title + ', ' + this.format(this.active.variant.price);
        }
      }
      async submit(event) {
        event.preventDefault();
        if (this.busy || !this.active.variant.available || !this.form.reportValidity()) return;
        this.busy = true;
        this.add.disabled = true;
        this.add.textContent = this.data.labels.adding;
        this.form.setAttribute('aria-busy', 'true');
        this.error.hidden = true;
        this.modeGroup.disabled = true;
        this.titleGroup.disabled = true;
        this.quantity.disabled = true;
        this.refreshQuantity();
        let added = false;
        const item = { id: this.active.variant.id, quantity: this.normalQuantity() };
        const root = window.Shopify?.routes?.root || '/';
        try {
          const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [item] }) });
          const result = await response.json();
          if (!response.ok || result.status >= 400) throw new Error(result.description || this.data.labels.error);
          added = true;
          this.status.textContent = this.data.labels.added;
          if (typeof window.openCart === 'function') await window.openCart();
          else window.location.assign(root + 'cart');
        } catch (error) {
          this.error.textContent = added ? this.data.labels.cart_error : (error.message || this.data.labels.error);
          this.error.hidden = false;
          this.querySelector('[data-book-cart]').hidden = !added;
        } finally {
          this.busy = false;
          this.modeGroup.disabled = false;
          this.titleGroup.disabled = false;
          this.quantity.disabled = false;
          this.form.removeAttribute('aria-busy');
          this.add.disabled = !this.active.variant.available;
          this.add.textContent = this.active.variant.available ? this.data.labels.add : this.data.labels.sold_out;
          this.refreshQuantity();
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["book-collection-choice"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('ocl-ocean-books')){customElements.define('ocl-ocean-books',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const dialog=this.querySelector('dialog');this.querySelector('[data-open-book]')?.addEventListener('click',()=>dialog.showModal());this.querySelector('[data-close-book]')?.addEventListener('click',()=>dialog.close());dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)dialog.close();}});}});}
  } catch(e) { console.error(e); }
})();

})();
